/**
 * Format des requêtes réseau enregistrées par le SDK : un événement rrweb de plugin
 * (`type: 6`, `data: { plugin, payload: NetworkRequest }`) par requête terminée, `plugin` étant
 * l'un des `NETWORK_PLUGINS` (cf. `isNetworkPlugin`).
 *
 * Jamais d'en-tête ; les URL sont nettoyées dans le navigateur (valeurs des paramètres sensibles
 * remplacées par `[masked]`). Les corps ne sont enregistrés que pour les réponses 4xx / 5xx, et
 * seulement si l'application l'a demandé (`captureErrorBodies`) : textes uniquement, valeurs des
 * clés sensibles masquées, tronqués à `MAX_NETWORK_BODY_LENGTH`. Ils ne vont que dans S3 (avec
 * l'enregistrement), jamais dans ClickHouse.
 */
/** Nom courant du plugin réseau du SDK dans les événements rrweb. */
export const NETWORK_PLUGIN = 'belvdr/network@1';
/**
 * Ancien nom du plugin réseau, d'avant le renommage en belvdr : celui des sessions déjà
 * enregistrées par un SDK antérieur. Toujours reconnu en lecture.
 */
export const LEGACY_NETWORK_PLUGIN = 'belvedere/network@1';
/** Noms du plugin réseau reconnus en lecture : le nom courant, puis l'ancien. */
export const NETWORK_PLUGINS = [NETWORK_PLUGIN, LEGACY_NETWORK_PLUGIN];
/** Ce nom de plugin rrweb est-il celui du plugin réseau (nom courant ou ancien) ? */
export function isNetworkPlugin(name) {
    return NETWORK_PLUGINS.some((plugin) => plugin === name);
}
/** Longueur maximale d'un corps enregistré, en caractères (cf. PRD : 10 Ko). */
export const MAX_NETWORK_BODY_LENGTH = 10 * 1024;
/** Erreur réseau : réponse 4xx / 5xx, ou requête sans réponse (hors annulation). */
export function isNetworkError(request) {
    if (request.failure !== undefined)
        return request.failure !== 'aborted';
    return request.status !== undefined && request.status >= 400;
}
